import {Box,Text} from "@chakra-ui/react";
import {MapHoverState} from "@ui/maps/common";
import {Popup} from "react-map-gl";

export interface DistancePopupProps extends MapHoverState {}

export default function DistancePopup(props: DistancePopupProps) {
  return (
    <Popup latitude={props.lat} longitude={props.lon} anchor="top">
      <Box bg="white" apply="styles.widgetStyles.card" p="2">
        <Text>{props.distance}</Text>
      </Box>
    </Popup>
  );
}
